<mat-form-field
  class="full-width"
  [ngClass]="{
    'density-4': fitShape(),
    'no-sub-wrapper': noSubWrapper(),
  }"
  [appearance]="fieldAppearance()">
  @if (!noLabel()) {
    <mat-label>Entity name</mat-label>
  }
  <input
    matInput
    placeholder="Entity name"
    #trigger="matAutocompleteTrigger"
    (blur)="onTouched()"
    [matAutocomplete]="companiesAutocomplete"
    (ngModelChange)="handleValChange($event)"
    [(ngModel)]="value" />

  @if (isShowLEISearch()) {
    <button
      matIconButton
      matSuffix
      class="primary-button"
      matTooltip="Search LEI database"
      [disabled]="fieldDisabled() || isFieldEmpty"
      (click)="searchLEIDatabase($event)">
      <mat-icon>public</mat-icon>
    </button>
  }

  @if (ngControl && ngControl.control?.invalid) {
    <mat-error>
      {{ errorsService.getErrorMessage(ngControl.control) }}
    </mat-error>
  }

  @if (originallyRequestedName()) {
    <mat-hint>Originally requested: {{ originallyRequestedName() }}</mat-hint>
  }
</mat-form-field>

<mat-autocomplete
  [displayWith]="displayFn"
  #companiesAutocomplete="matAutocomplete"
  (optionSelected)="handleSelect($event)">
  @for (option of options$ | async; track option.lei.id) {
    <mat-optgroup [label]="option.lei.attributes.lei">
      @for (name of option.names; let index = $index; track name + index) {
        <mat-option [value]="{ name: name, lei: option.lei }">
          <span>
            <ume-flag [code]="option.lei.attributes.entity.legalAddress.country"></ume-flag>
            {{ name }}
          </span>
        </mat-option>
      }
    </mat-optgroup>
  }
</mat-autocomplete>
